export const VEHICLE_TYPE_NAMES = {
  gasoline: "Gasolina",
  diesel: "Gasóleo",
  hybrid: "Híbrido",
  motorcycle: "Motocicleta",
};
